<template>
    <div 
        class="table-treeview"
        :class="{'preloader-content': isPreloader}"
    >
        <div
            v-if="isPreloader"
            class="preloader fa fa-circle-o-notch fa-spin">
        </div>
        <table-tabs
            :tableTabs="tableTabs"
            :tableTabKeyActive="tableTabActive"
            @onClickTab="onClickTab"
        />
        <div class="table-treeview_container">
        <table>
            <thead>
                <tr class="table-tr__section">
                    <th
                        v-for="(columnKey, columnKeyIndex) in Object.keys(tableDataColumns)"
                        :key="`${columnKey}_${columnKeyIndex}`"
                        :style="getStyleCell(columnKey)"
                        class="table-multiline__td-name"
                    >
                        <table-header
                                :isSort="isSort && Object.keys(columnsSort).includes(columnKey)"
                                :sortState="sortColumn === columnKey ? sortState : 0"
                                :title="tableDataColumns[columnKey]"
                                @onToggleSort="onToggleSort($event, columnKey)"
                        />
                    </th>
                </tr>
            </thead>
            <tbody 
                v-if="tableDataRows.size !== 0"
                :key="render"
            >
                <table-treeview-item
                    v-for="(rowKey, rowKeyIndex) in tableDataRows.keys()"
                    :key="`${rowKey}_${rowKeyIndex}`"
                    :tableDataOptions="tableDataOptions"
                    :tableDataColumns="tableDataColumns"
                    :tableDataRows="tableDataRows"
                    :tableDataRowsActive="tableData.rowsActive"
                    :rowKey="rowKey"
                    :rowKeyPreloader="tableData.rowKeyPreloader"
                    :tableSubdata="tableData.subdata[rowKey] || {}"
                    :condition="{}"
                    :tableTabKeyActive="tableTabActive"
                    @onEmitClickTableItem="onClickTableItem"
                />
            </tbody>
        </table>
        </div>
    </div>
        
</template>

<script>
import TableTreeviewItem from './TableTreeviewItem';
import TableTabs from './TableTabs';
import TableHeader from './TableHeader';
export default {
    name: 'TableTreeview',
    components: {
        TableTreeviewItem,
        TableTabs,
        TableHeader
    },
    /**
     * Входные данные компонента
     * @property {boolean} isPreloader - условие показа прелоадера
     * @property {object} tableData - данные таблицы
     * @property {object} tableTabs - табы
     * @property {boolean} isSort - вкл/откл сортировку
     * @property {object} columnsSort - колонки которые можно сортировать
     * @property {Object} columnsStyles - стили колонок
     * @property {number} sortState - режим сортировки
     * @property {string} sortColumn - колонка по которой сортируем
     * @property {number} render - рендер
     */
    props: {
        isPreloader: {
            type: Boolean,
            default: false
        },
        tableTabs: {
            type: Object,
            default: () => ({})
        },
        tableData: {
            type: Object,
            default: () => ({})
        },
        isSort: {
            type: Boolean,
            default: false
        },
        columnsSort: {
            type: Object,
            default: () => ({})
        },
        columnsStyles: {
            type: Object,
            default: () => ({})
        },
        sortState: {
            type: Number,
            default: 0
        },
        sortColumn: {
            type: String,
            default: ''
        },
        render: {
            type: Number,
            default: 0
        }
    },
    /**
     * данные компонента
     * @property {string} tableTabActive - активный таб
     */
    data: () => ({
        tableTabActive: 'default',
    }),
    computed: {
        /**
         * опции
         * @returns {object}
         */
        tableDataOptions() {
            let {options = {}} = this.tableData;
            return options;
        },
        /**
         * колонки
         * @returns {object}
         */
        tableDataColumns() {
            let {columns = {}} = this.tableData;
            return columns;
        },
        /**
         * строки
         * @returns {map}
         */
        tableDataRows() {
            let {rows = new Map()} = this.tableData;
            return rows;
        },
    },
    watch: {
        /**
         * при изменении входных данных выставляем активный таб
         */
        tableTabs: function() {
            this.tableTabActive = Object.keys(this.tableTabs)[0]
        }
    },
    methods: {
        /**
         * получить стиль ячейки
         * @param {string} columnKey - ключь колонки
         * @returns {Object}
         */
        getStyleCell(columnKey = '') {
            let styleCell = this.columnsStyles.hasOwnProperty(columnKey) ? this.columnsStyles[columnKey] : {};
            return styleCell;
        },
        /**
         * событие клика по строке таблицы
         * @param {object} condition - элементы иерархии дерева
         * @param {string} element - ключ элемента
         * @param {string} rowKey - ключ строки
         */
        onClickTableItem(condition, element, rowKey) {
            this.$emit('onClickTableItem', condition, element, rowKey);
        },
        /**
         * событие клика по табу
         * @param {string} tabKey - ключ таба
         */
        onClickTab(tabKey) {
            this.tableTabActive = tabKey;
            this.$emit('onClickTreeTab', tabKey);
        },
        /**
         * переключение режима сортировки
         * @param {string} currentSortState - текущее состояние режима сортировки
         * @param {string} column - колонка по которой сортируем
         */
        onToggleSort(currentSortState, column) {
            this.$emit('onToggleSort', currentSortState, column);
        }
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep.table-treeview {
        position: relative;
        // overflow-x: auto;
    }
    ::v-deep.table-treeview_container {
        overflow-x: auto;
    }
    /*::v-deep.table-treeview table {*/
    /*    border-collapse: collapse;*/
    /*    width: 100%;*/
    /*}*/
    /*::v-deep.table-treeview th {*/
    /*    font-family: Arial;*/
    /*    font-weight: bold;*/
    /*    text-align: left;*/
    /*    border: 1px solid #ddd;*/
    /*    padding: 5px 5px 5px 5px;*/
    /*}*/
    /*::v-deep.table-treeview td {*/
    /*    position: relative;*/
    /*    border: 1px solid #ddd;*/
    /*    padding: 5px 5px 5px 5px;*/
    /*}*/
    /*.table-treeview__th-container {*/
    /*    display: flex;*/
    /*    justify-content: space-between;*/
    /*    align-items: center;*/
    /*}*/
    /*.table-treeview__sort {*/
    /*    visibility: hidden;*/
    /*}*/
    /*.table-treeview th:hover .table-treeview__sort {*/
    /*    visibility: visible;*/
    /*}*/
    /*.table-treeview__sort_active {*/
    /*    visibility: visible;*/
    /*}*/
    table {
        width: 100%;
        border-radius: 10px;
        overflow: hidden;
        border-collapse: collapse;
        border-spacing: 0;
    }

    thead th{
        border-bottom: 1px solid #f5f7f9;
    }

    thead th{
        padding: 16px 14px;
    }

    thead th {
        text-align: left;
        font-weight: bold;
        text-transform: uppercase;
        color: #000;
        letter-spacing: 0.07em;
        word-break: break-all;
        font-size: 0.65em;
    }

    .table-treeview__th-container {
        cursor: pointer;
    }

    thead {
        border-bottom: 3px solid #f5f7f9;
    }

    .table-tr__section {
        background: #f5f7f9;
    }

    thead th.table-multiline__td-name{
        border-right: 3px solid #f5f7f9;
        width: 300px;
        white-space: nowrap;
    }

    .table-multiline__td-number {
        text-align: right;
        position: relative;
        white-space: nowrap;
    }

    .table-multiline__cell-val {
        display: block;
    }

    .table-multiline__cell-diff {
        display: block;
        font-size: 0.65em;
        color: #b0b1b4;
        opacity: 1;
        visibility: visible;
        position: absolute;
        right: 14px;
        bottom: 4px;
    }

    // tbody tr:hover .table-multiline__cell-diff {
    //     opacity: 1;
    //     visibility: visible;
    // }

    .txt_right {
        text-align: right;
    }
    .table-treeview__th-container {
        cursor: pointer;
    }
</style>